import { ChangeDetectionStrategy, Component, Input, Signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ScheduleCalendarVM } from '../schedule-calendar.vm';

@Component({
  selector: 'lib-schedule-calendar-header',
  templateUrl: './schedule-calendar-header.component.html',
  styleUrl: './schedule-calendar-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
})
export class ScheduleCalendarHeaderComponent {
  @Input() public isScheduleLoadingSignal!: Signal<boolean>;
  @Input() public columnLoadingSkeletons!: unknown[];
  @Input() public operatories!: ScheduleCalendarVM[];
}
